//** Product Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getProduct = createAsyncThunk('productSlice/getProduct', async () => {
    try {
        let response = await axios.get('/product', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getProductOption = createAsyncThunk('productSlice/getProductOption', async () => {
    try {
        let response = await axios.get('/product/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getProductById = createAsyncThunk('productSlice/getProductById', async (data) => {
    try {
        let response = await axios.get('/product/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createProduct = createAsyncThunk('productSlice/createProduct', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/product', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Product added successfully.');
        dispatch(getProduct());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateProduct = createAsyncThunk('productSlice/updateProduct', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/product/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Product updated successfully.');
        await dispatch(getProduct());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateProductStatus = createAsyncThunk('productSlice/updateProductStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/product/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || ' Status updated successfully !');
        dispatch(getProduct());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteProduct = createAsyncThunk('productSlice/deleteProduct', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/product/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Product deleted successfully.');
        await dispatch(getProduct());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const productSlice = createSlice({
    name: 'productSlice',
    initialState: {
        data: [],
        option: [],
        selectedProduct: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProduct.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getProductOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
        builder.addCase(getProductById.fulfilled, (state, action) => {
            state.selectedProduct = action.payload;
            return;
        });
    }
});

export default productSlice.reducer;
